import React, { useState } from 'react'
import { BsArrowRightShort } from 'react-icons/bs'
import pay from "../../Assets/paySS.png"

const contribution = [
    { id: 0, per: "0.5%", value: "Starting" },
    { id: 1, per: "1%", value: "Most popular" },
    { id: 2, per: "1.5%", value: "High impact" }
]

const ClimateStep = ({ setStep, setMainStep }) => {
    const [data, setData] = useState('')
    const [checkValue, setCheckValue] = useState(false)

    const handleContinue = () => {
        setMainStep('step5')
        setStep('Summary')
    }

    return (
        <div>
            <div>
                <div class="p-[1px_6px] border-[1px] border-[#d5dbe1] w-max rounded-md h-fit text-[#545969] flex items-center justify-center bg-[#ebeef1] text-xs font-semibold">Optional</div>
                <h3 className='text-[#30313d] mt-1 sm:text-[32px] text-[24px] font-semibold leading-[42px]'>Show customers your climate commitment</h3>
                <p className='text-[#414552] mt-2'>With <span className='text-base text-[#625afa] font-semibold'>Stripe Climate</span>, you can direct a fraction of your revenue from payments to fund permanent carbon removal.</p>
                <div className="sm:mt-[40px] mt-[20px]">
                    <div className='text-[#1a1b25] relative'>
                        <h3 className='text-base font-semibold'>Set your contribution</h3>
                        <p className='text-sm mt-2 text-[#414552]'>Every dollar will fund next-generation carbon removal. Edit your program anytime from your account settings.</p>
                        <div className='group relative'>
                            <div className='flex gap-3 mt-5 w-full'>
                                {contribution.map((val, i) => {
                                    return (
                                        <div className={`${data.id === i ? "border-[2px] border-[#625afa] w-[160%]" : "border-[1px] w-full border-[#e0e1e3]"} transition-all flex flex-col select-none gap-2 items-center h-[120px] justify-center p-[16px] rounded-[6px] text-[#414552] cursor-pointer`} key={i} onClick={() => setData(val)}>
                                            {data.id === i && <h5 className='text-xs whitespace-nowrap uppercase text-[#687385]'>{data.value}</h5>}
                                            <h3 className='text-[20px] font-semibold'>{val.per}</h3>
                                            {data.id === i && <p className='text-xs'>{data.per && 'of revenue'}</p>}
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="mt-7">
                                <div className="relative flex items-center mt-5">
                                    <div className="flex items-center">
                                        <input id="check-1" name="business" type="checkbox" className="h-[15px] w-[15px] border-gray-300 accent-indigo-600 rounded" value={checkValue} checked={checkValue} onChange={() => setCheckValue(!checkValue)} />
                                    </div>
                                    <div className="ml-2 text-sm">
                                        <label htmlFor="check-1" className="select-none cursor-pointer font-semibold text-[#414552] ">Start contributing after my business has processed:</label>
                                    </div>
                                </div>
                                <div className='mt-3 ml-5 relative'>
                                    <input type="number" disabled={checkValue ? false : true} className={`${checkValue ? "bg-white" : " bg-[#f6f8fa]"} input_focus_shadow text-[#404452] pl-5 pr-36 w-full font-normal rounded-[6px] focus:outline-none h-[28px] py-1 text-[14px] transition-all`} placeholder='–' />
                                    <span className='text-sm text-[#414552] absolute top-[50%] translate-y-[-50%] left-2'>$</span>
                                    <span className='text-sm text-[#414552] absolute top-[50%] translate-y-[-50%] right-2'> of revenue with Stripe</span>
                                </div>
                            </div>
                        </div>
                        <div className='block show-text opacity-100'>
                            <div className="relative">
                                <img src={pay} alt="" />
                                <div className='absolute w-[85%] left-[50%] translate-x-[-50%] top-[140px] bg-white p-2'>
                                    <div className='w-full flex gap-2 items-center'>
                                        <div className='badgeIcon'></div>
                                        <p className='text-[10px] leading-[13px] text-[#687385]'>
                                            {data === '' ? "Applogika LLC will contribute a portion of your purchase to remove CO₂ from the atmosphere." :
                                                `Applogika LLC will contribute ${data.per} of your purchase to remove CO₂ from the atmosphere.`
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <p className='text-xs text-[#414552] mt-5'>Enable the Stripe Climate badge to easily share contributions with customers.</p>
                        </div>
                    </div>
                    <div className='mt-6 pb-5'>
                        <button onClick={handleContinue} className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>Continue {data.per && <span>with {data.per}</span>}<BsArrowRightShort className='text-[25px]' /></button>
                        <button onClick={handleContinue} className="input_focus_shadow rounded-md w-full mt-3 flex items-center gap-1 font-medium h-[36px] pl-2 pr-3 py-2 justify-center text-[#414552]">No thanks</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClimateStep